import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import { CurrencyProvider } from "./context/CurrencyContext";
import Header from "./components/Header";
import HomePage from "./pages/HomePage";
import ShopPage from "./pages/ShopPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import CheckoutPage from "./pages/CheckoutPage";
import OrderStatusPage from "./pages/OrderStatusPage";
import AboutPage from "./pages/AboutPage";
import AdminPage from "./pages/AdminPage";
import PortfolioPage from "./pages/PortfolioPage";
import MailClubPage from "./pages/MailClubPage";
import InteriorPage from "./pages/InteriorPage";

function App() {
  return (
    <CurrencyProvider>
    <CartProvider>
      <BrowserRouter>
        <div className="min-h-screen relative">
          <div
            className="fixed inset-0 z-0 pointer-events-none"
            style={{
              backgroundImage: `url("data:image/svg+xml,%3Csvg width='50' height='50' xmlns='http://www.w3.org/2000/svg'%3E%3Cline x1='50' y1='0' x2='50' y2='50' stroke='%2387CEEB' stroke-width='1.5'/%3E%3Cline x1='0' y1='50' x2='50' y2='50' stroke='%2387CEEB' stroke-width='1.5'/%3E%3C/svg%3E")`,
              backgroundSize: "50px 50px",
            }}
          />
          <div className="relative z-10">
          <Header />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/shop" element={<ShopPage />} />
            <Route path="/product/:id" element={<ProductDetailPage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/order/:orderId" element={<OrderStatusPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/portfolio" element={<PortfolioPage />} />
            <Route path="/mail-club" element={<MailClubPage />} />
            <Route path="/interior" element={<InteriorPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          </div>
        </div>
      </BrowserRouter>
    </CartProvider>
    </CurrencyProvider>
  );
}

export default App;
